var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('copy-from', {
    attrs: {
      "dataForm": _vm.dataForm,
      "options": _vm.serviceList,
      "labelFormatter": function labelFormatter(item) {
        return "[".concat(item.serviceCode, "]").concat(item.description);
      }
    },
    on: {
      "copyFromTrigger": _vm.copyFromTrigger
    }
  })], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Code",
      "prop": "serviceCode"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "clearable": "",
      "placeholder": "SG-N1"
    },
    model: {
      value: _vm.dataForm.serviceCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceCode", $$v);
      },
      expression: "dataForm.serviceCode"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Country"
    },
    on: {
      "change": _vm.countryChange
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessTypeList"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" Business Type "), _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "content": "Select country first"
    }
  }, [_c('i', {
    staticClass: "el-icon-info",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _c('el-select', {
    staticClass: "fluid-width",
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "Select Business Type"
    },
    model: {
      value: _vm.dataForm.businessTypeList,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "businessTypeList", $$v);
      },
      expression: "dataForm.businessTypeList"
    }
  }, _vm._l(_vm.supportBusinessTypesOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "supplierId"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" Supplier "), _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "content": "Select country first"
    }
  }, [_c('i', {
    staticClass: "el-icon-info",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _c('el-select', {
    staticClass: "fluid-width",
    attrs: {
      "clearable": "",
      "placeholder": "Select Supplier"
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierList, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Description (EN)",
      "prop": "description"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "clearable": "",
      "placeholder": "Description (EN)"
    },
    model: {
      value: _vm.dataForm.description,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "description", $$v);
      },
      expression: "dataForm.description"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Description (CN)",
      "prop": "descriptionCn"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Description (CN)"
    },
    model: {
      value: _vm.dataForm.descriptionCn,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "descriptionCn", $$v);
      },
      expression: "dataForm.descriptionCn"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Description (Local)",
      "prop": "descriptionLocal"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Description (Local)"
    },
    model: {
      value: _vm.dataForm.descriptionLocal,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "descriptionLocal", $$v);
      },
      expression: "dataForm.descriptionLocal"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Service Scope (EN)",
      "prop": "serviceScope"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "type": "textarea",
      "rows": 3,
      "resize": "none",
      "clearable": "",
      "placeholder": "Service Scope (EN)"
    },
    model: {
      value: _vm.dataForm.serviceScope,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceScope", $$v);
      },
      expression: "dataForm.serviceScope"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Service Scope (CN)",
      "prop": "serviceScopeCn"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "resize": "none",
      "clearable": "",
      "placeholder": "Service Scope (CN)"
    },
    model: {
      value: _vm.dataForm.serviceScopeCn,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceScopeCn", $$v);
      },
      expression: "dataForm.serviceScopeCn"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Currency",
      "prop": "currency"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Select Currency"
    },
    model: {
      value: _vm.dataForm.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "currency", $$v);
      },
      expression: "dataForm.currency"
    }
  }, _vm._l(_vm.currencyList, function (item) {
    return _c('el-option', {
      key: item.currency,
      attrs: {
        "label": item.currency,
        "value": item.currency
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "serviceFee"
    }
  }, [_c('el-input', {
    directives: [{
      name: "positivePoint",
      rawName: "v-positivePoint"
    }],
    attrs: {
      "placeholder": "0.00"
    },
    model: {
      value: _vm.dataForm.serviceFee,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceFee", $$v);
      },
      expression: "dataForm.serviceFee"
    }
  }, [_c('template', {
    slot: "prefix"
  }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.dataForm.currency)))])], 2)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Original Price",
      "prop": "originalServiceFee"
    }
  }, [_c('el-input', {
    directives: [{
      name: "positivePoint",
      rawName: "v-positivePoint"
    }],
    attrs: {
      "placeholder": "0.00"
    },
    model: {
      value: _vm.dataForm.originalServiceFee,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "originalServiceFee", $$v);
      },
      expression: "dataForm.originalServiceFee"
    }
  }, [_c('template', {
    slot: "prefix"
  }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.dataForm.currency)))])], 2)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Third Party Fee",
      "prop": "thirdPartyFee",
      "rules": {
        required: _vm.dataForm.thirdPartyFeeDescription ? true : false,
        message: 'please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "positivePoint",
      rawName: "v-positivePoint"
    }],
    attrs: {
      "placeholder": "0.00"
    },
    model: {
      value: _vm.dataForm.thirdPartyFee,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "thirdPartyFee", $$v);
      },
      expression: "dataForm.thirdPartyFee"
    }
  }, [_c('template', {
    slot: "prefix"
  }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.dataForm.currency)))])], 2)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Other Fee",
      "prop": "otherFee",
      "rules": {
        required: _vm.dataForm.otherFeeDescription ? true : false,
        message: 'please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "positivePoint",
      rawName: "v-positivePoint"
    }],
    attrs: {
      "placeholder": "0.00"
    },
    model: {
      value: _vm.dataForm.otherFee,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "otherFee", $$v);
      },
      expression: "dataForm.otherFee"
    }
  }, [_c('template', {
    slot: "prefix"
  }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.dataForm.currency)))])], 2)], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Note For Third Party Fee (EN)",
      "prop": "thirdPartyFeeDescription",
      "rules": {
        required: _vm.$isNumberLike(_vm.dataForm.thirdPartyFee) ? true : false,
        message: 'please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "EN"
    },
    model: {
      value: _vm.dataForm.thirdPartyFeeDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "thirdPartyFeeDescription", $$v);
      },
      expression: "dataForm.thirdPartyFeeDescription"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Note For Third Party Fee (CN)",
      "prop": "thirdPartyFeeDescriptionCn"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "CN"
    },
    model: {
      value: _vm.dataForm.thirdPartyFeeDescriptionCn,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "thirdPartyFeeDescriptionCn", $$v);
      },
      expression: "dataForm.thirdPartyFeeDescriptionCn"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Note For Third Party Fee (Local)",
      "prop": "thirdPartyFeeDescriptionLocal"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Local"
    },
    model: {
      value: _vm.dataForm.thirdPartyFeeDescriptionLocal,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "thirdPartyFeeDescriptionLocal", $$v);
      },
      expression: "dataForm.thirdPartyFeeDescriptionLocal"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Note For Other Fee (EN)",
      "prop": "otherFeeDescription",
      "rules": {
        required: _vm.$isNumberLike(_vm.dataForm.otherFee) ? true : false,
        message: 'please enter',
        trigger: 'submit'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "EN"
    },
    model: {
      value: _vm.dataForm.otherFeeDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "otherFeeDescription", $$v);
      },
      expression: "dataForm.otherFeeDescription"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Note For Other Fee (CN)",
      "prop": "otherFeeDescriptionCn"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "CN"
    },
    model: {
      value: _vm.dataForm.otherFeeDescriptionCn,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "otherFeeDescriptionCn", $$v);
      },
      expression: "dataForm.otherFeeDescriptionCn"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Note For Other Fee (Local)",
      "prop": "otherFeeDescriptionLocal"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Local"
    },
    model: {
      value: _vm.dataForm.otherFeeDescriptionLocal,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "otherFeeDescriptionLocal", $$v);
      },
      expression: "dataForm.otherFeeDescriptionLocal"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Sort No.",
      "prop": "orderNum"
    }
  }, [_c('el-input', {
    directives: [{
      name: "positiveInteger",
      rawName: "v-positiveInteger"
    }],
    attrs: {
      "clearable": "",
      "placeholder": "Order Number"
    },
    model: {
      value: _vm.dataForm.orderNum,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "orderNum", $$v);
      },
      expression: "dataForm.orderNum"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Status",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: _vm.dataForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "status", $$v);
      },
      expression: "dataForm.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("Disable")]), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("Enable")])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "pt16"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("Submit")]), _c('el-button', {
    on: {
      "click": function click() {
        return _vm.$router.replace('/sys/pkg/module');
      }
    }
  }, [_vm._v("Back")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }